
export class FirebaseUser {
    email: string;
    uid: string;
    displayName: string;
    emailVerified: boolean;
    phoneNumber: string;
    photoUrl: string;
    provider: string;
    token: string;
    refreshToken: string;
}
